require('./index.less');

var Marionette = require('marionette'),
    $ = require('jquery'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV'),
    DocModeContainer = require('../viewModes/docMode/docModeContainer'), //TODO: create mixin for dmc and this
    ThumbImgWr = require('../page/thumbnail/pgThumb'),
    UnRenderableThumb = require('../page/thumbnail/unrenderableThumb/unrenderableThumb'),
    UrlThumb = require('../page/thumbnail/urlThumb/view'),
    MultiPartGosPgThumb = require('../page/thumbnail/multipartGosThumb/view');


require('jqLazyLoad');
require('backbone.radio'); //(simple enough now for now supapp ....)


module.exports = Marionette.CompositeView.extend({

    lazyLoadDelay: 500,   //delay also prevents from loading too many images
    template: require('./thumbNails.hbs'),
    childViewContainer: '.thumb-scroller',

    constructor: function(options) {

        // Prevent need to pass in option -- greatly optimizes for pages with large documents
        // Note: not helping perf like the Doc Mode Container
        this.sort = false;

        Marionette.CompositeView.prototype.constructor.apply( this, arguments );

        // From old initialize:
        _.bindAll(this, 'checkForPagesInView');

        _.extend(this, Backbone.Radio.Channel.prototype);

        this.reply({
            childViews: function() {
                return this.children;
            }
        });

        this.comply({
            checkInView: _.partial(this.checkForPagesInView),
            listenForThumbsToBeInView: this._listenForThumbsToBeInView,
            goToThumb: this.goToThumb
        });

    },

    getChildView: function(model) {

        if ( model.renderUrlViewForThumbnail() )
            return UrlThumb;

        if ( model.isMultipartGos() )
            return MultiPartGosPgThumb;

        return model.isRenderable()
            ? ThumbImgWr
            : UnRenderableThumb;

    },

    childViewOptions: function() {
        return {
            vChannel: this.options.vChannel,
            parent: this
        };
    },

    ui: {
        thumbScroller:  '.thumb-scroller-wr',
        thumbContainer: '.thumb-scroller'
    },

    onRender: function() {

        this.unwrap();
        this.ui.thumbScroller.scrollTop(0);
        this.options.vChannel.request('loadImages') && this._listenForThumbsToBeInView();
        this.ui.thumbScroller.on('scroll', _.bind(this.onScroll, this)); //scroll event does not delegate: can't put in events hash

    },

    onScroll: function(e) {
        this.options.vChannel.command('forceClosePageActionDropdownMenus');
    },
    /* separated from onRender in case loadImages = false; so also called from toggle allow images to load */
    _listenForThumbsToBeInView: function() {
        $(this.children.pluck('el')).lazyLoad({
            container: this.ui.thumbScroller,
            delay: this.lazyLoadDelay,
            skipClass: 'invisible'
        });
    },

    // Apply to the direct parent container -- fires the event (not the scroll event handler already set)
    checkForPagesInView: function() {

        this.ui.thumbContainer.trigger('checkInView');

    },

    /**
     * Link between main scroller and sidescroller.
     * Basically calc the current top and bottom thresholds of the container and see if the element is in the above or below it)
     **/
    goToThumb: function( pgOrThumb ) {

        var vCh = this.options.vChannel,
            thumbModel = pgOrThumb instanceof this.collection.at(0).constructor  //* always convert to thumbNail */
                ? pgOrThumb
                : vCh.request('getThumbFromPageModel', pgOrThumb),
            thumbView = this.children.findByModel(thumbModel),
            $thumbEl = $(thumbView.el),
            thumbPadding = fvChannel.request('cssConstants').V_PADDING,
            tsScrollTop = this.ui.thumbScroller.scrollTop(), //the outer
            thumbHeight = thumbModel.getRotatedHeight() + (2 * thumbPadding),

            //calc these from the vThumbOffsets
            currentThumbBottom = $thumbEl.position().top + thumbHeight + thumbPadding + tsScrollTop,   //can also use the voffset of the prior page + thumbPadding
            currentThumbTop = currentThumbBottom - thumbHeight,
            topYThreshold = tsScrollTop,
            bottomYThreshold = this.ui.thumbScroller.height() +  tsScrollTop,  //(the bottom of the abs div + any scrolltop amt
            scrollToPosition = 0;

        thumbView.highlight();

        /* scroll */
        if (currentThumbBottom > bottomYThreshold) {    //if bottom of the current thumb is below the threshold

            scrollToPosition = currentThumbTop  - thumbPadding; //set thumbscrollerTop to the top of the current page position
            this.ui.thumbScroller.scrollTop(scrollToPosition );               //this one is accurate

        } else if (currentThumbTop < topYThreshold) {

            var prevThumb = this.collection.at( this.collection.indexOf(thumbModel) - 1 ),
            prevThumbView = prevThumb  ? this.children.findByModel(prevThumb) : null,
            scrollToPosition = prevThumb ? currentThumbTop - $(prevThumbView.el).position().top - (3 * thumbHeight) - thumbPadding : 0; //(top if the first page)

            // The latter will be negative
            // This is rather random ... fix ?
            this.ui.thumbScroller.scrollTop(scrollToPosition );

        }
    },

    onClearActiveThumb: function() {

        this.children.findByModel( this.options.vChannel.request('currentPage') );
        this.$('.active').removeClass('active');

    },

    destroy: function() {

        Backbone.Radio.Channel.prototype.reset.call(this);
        this.ui.thumbScroller.trigger('lazyload.destroy');
        this.ui.thumbScroller.off('scroll');

        Marionette.CompositeView.prototype.destroy.apply(this, arguments);

        //quick fix for jqCache clear --- the ui elements are detached -- mostly removed
        this.$('*').remove();
        this.el = null;
        this.$el = null;

    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/thumbnails/thumbNails.js
 ** module id = 560
 ** module chunks = 0
 **/